module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('markup-wrapper', {
    staticClass: "page-text"
  }, [(_vm.$slots.sub) ? _c('div', {
    staticClass: "page-text__sub"
  }, [_vm._t("sub")], 2) : _vm._e(), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd838ade","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/text/Text.vue
// module id = 336ee75e0c92c816b0dc
// module chunks = 0